$(document).ready(function () {

  initURLTarget(); // Initialise les data target cliquables
  initSwipers(); // Initialisation des swiper de cartes produits
  initPagination(); // Initialisation du lazy loading sur les pages collections

  // Diaporama home page
  if ($('.diaporama').length) {
    var timing = $('.diaporama').data("timing") * 1000;
    $('.diaporama').slick({
      infinite: true,
      slidesToShow: 1,
      dots: true,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: timing,
      pauseOnHover: false,
      pauseOnDotsHover: false
    });
  }

  if ($(".diaporama").length) {
    $(document).on('click', '.diaporama .slick-slide', function () {
      var redirect = $(this).find("a").attr("href");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  // Gestion des filtres sur les PLP
  $('#toggle_filters').click(function () {
    const filters = $('#main-collection-filters');
    if (!filters.hasClass('open')) {
      filters.css('display', 'block'); // afficher d'abord le bloc pour que l’animation fonctionne
      filters[0].offsetHeight; // forcer un "repaint" du navigateur
      filters.addClass('open'); // ajouter la classe qui déclenche la transition
    }
    else {
      filters.removeClass('open'); // retirer la classe qui déclenche la fermeture
      setTimeout(() => { // attendre la fin de l'animation avant de cacher
        filters.css('display', 'none');
      }, 150); // correspond à la durée de la transition
    }
  });

  // Mise à jour de la date de livraison
  if ($(".estimated_delivery span").length) {
    adjust_delivery_time();
  }

  // Barre d'annonce
  // --------------------------------------------
  // Click sur le bouton de fermeture de la barre
  $('.close_announcement_bar').click(function (e) {
    e.preventDefault();
    $(this).remove();

    // Transition de fermeture
    $('.announcement-bar-section').slideUp(150, function () {
      $(this).remove();
    })

    // On stocke en session la demande de fermeture
    sessionStorage.setItem("closed_announcement", "true");
  });

  // Header Desktop
  $('.header__inline-menu .list-menu__item').click(function () {

    // Cache tous les autres menus d'abord
    $('.header__inline-menu .list-menu__item').not(this).each(function() {
      $(this).find(".mega-menu__content").stop().fadeOut(100);
      $(this).find("a").removeClass("actif");
      $(this).find(".mega-menu__content .level3 .js_grandchildren").removeClass("actif").hide();
    });

    // Basculer l'affichage du menu actuel
    if ($(this).find(".mega-menu__content").is(':visible')) {
      console.log("fermeture du menu");
      $(this).find(".mega-menu__content").stop().fadeOut(100);
      $(this).find("a").removeClass("actif");
      $(this).find(".mega-menu__content .level3 .js_grandchildren").removeClass("actif").hide();
    } else {
      console.log("ouverture du menu");
      $(this).find(".mega-menu__content").stop().fadeIn(100);
      $(this).find(".mega-menu__content .level3 .js_grandchildren:first-of-type").addClass("actif").fadeIn(0);
    }
  });

    // Gestion du clic en dehors du menu
  $(document).click(function (e) {
    if (!$(e.target).closest('.header__inline-menu').length) {
      // Si le clic ne se fait pas dans le menu, fermer tous les menus
      $('.header__inline-menu .list-menu__item').each(function () {
        $(this).find(".mega-menu__content").stop().fadeOut(100);
        $(this).find("a").removeClass("actif");
        $(this).find(".mega-menu__content .level3 .js_grandchildren").removeClass("actif").hide();
      });
    }
  });

  // Rollover sur les sous-catégories
  $('.level2 a').hover(
    function () {
      var target = $(this).data("target");
      var push = $(this).data("push");
      $(this).parent().parent().find(".js_grandchildren").removeClass("actif").hide();
      $(this).parent().find("a").removeClass("actif");
      $(this).parent().parent().find("[data-origin='" + target + "']").show().addClass("actif");
      $(this).addClass('actif');
      $(this).parent().parent().find(".push_image img").attr('src', push);
    }
  );

   if ($(window).width() < 990) {

    $(document).on("click", ".header__icon--menu", function() {
      $('.header__icon--menu').toggleClass('open_icon');
      $('.header__icon--menu').toggleClass('close_icon');

      // si la class open_icon est présente alors on la retire et on ajoute la class close_icon
      if ($('.header__icon--menu').hasClass('open_icon')) {
        $('.menu-drawer__menu-item_1, .menu-drawer__menu-item_2, .menu-drawer__close-button_1, .childlink_title_1, .slider_images_mobile').css('transform', 'translate(0)');
      } else {
        // si la class close_icon est présente alors on la retire et on ajoute la class open_icon
        $('.header__icon--menu').removeClass('close_icon').addClass('open_icon');
      }
    });
  }

  // Sticky Basket
  const add_to_cart_buttons = $('.product-form__buttons');
  const sticky_basket = $('#sticky_basket');

  $(document).scroll(function () {
    if (add_to_cart_buttons.length === 0) {
      return;
    }
    const isVisible = isInViewport(add_to_cart_buttons);
    if (isVisible) {
      sticky_basket.slideUp(200);
    }
    else {
      sticky_basket.slideDown(200);
    }
  });

  // Header mobile
  // si je clique sur un details de menu de class class="menu-drawer__menu-item_1 alors je mets l'opactité de son enfant direct summary à 0
  $(document).on("click", "summary.menu-drawer__menu-item_1", function() {
    $('.menu-drawer__menu-item_1').css('transform', 'translate(-105%)');
  });

  $(document).on("click", "summary.menu-drawer__menu-item_2", function() {
    $('.menu-drawer__menu-item_2, .menu-drawer__close-button_1, .childlink_title_1, .slider_images_mobile').css('transform', 'translate(-105%)');
  });

  $(document).on("click", ".menu-drawer__close-button_1", function() {
    $('.menu-drawer__menu-item_1').css('transform', 'translate(0)');
  });

  $(document).on("click", ".menu-drawer__close-button_2", function() {
    $('.menu-drawer__menu-item_2, .menu-drawer__close-button_1, .childlink_title_1, .slider_images_mobile').css('transform', 'translate(0)');
  });

  $(document).on("click", ".header__icon--menu", function() {
    $('.menu-drawer__menu-item_2, .menu-drawer__close-button_1, .childlink_title_1, .slider_images_mobile').css('transform', 'translate(0)');
    $('.menu-drawer__menu-item_1').css('transform', 'translate(0)');
  });

  // Ajout du fond blur si le menu est ouvert
  const targetNode = document.querySelector('.menu-drawer-container');
  const config = { attributes: true, childList: false, subtree: false };
  const callback = function(mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        checkMenuOpening();
      }
    }
  };
  const observer = new MutationObserver(callback);
  if (targetNode) {
    observer.observe(targetNode, config);
  }
  $(window).on('resize', function() {
    checkMenuOpening();
  });

  // Sticky button sur fiche produit
  $(".sticky_button").click(function () {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".product__info-wrapper").offset().top
    }, 400);
  })

  // FAQ
  $('.question').click(function () {
    $(this).find(".caret").toggleClass("actif");
    $(this).parent().find(".answer").slideToggle(200);
  })

});

// Fonction pour initialiser la pagination
function initPagination() {
  // Lazy loading sur les pages Collections
  $('.js-load-more').on('click', function () {
    var $this = $(this), totalPages = parseInt($('[data-total-pages]').val()), currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (responseHTML) {
        // On enrichi la liste des produits
        $('#product-grid').append($(responseHTML).find('#product-grid').html());
        // On met à jour le nombre de produits affichés
        $('.pagination_count').html($(responseHTML).find('.pagination_count').html());
        // On met à jour le nombre de produits restants
        $('.pagination_progress').html($(responseHTML).find('.pagination_progress').html());
        // recharge les swipers
        initSwipers();
        initURLTarget();
      },
      complete: function () {
        if (currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        }
        if (currentPage == totalPages) {
          $this.hide();
        }
      }
    })
  });

}

// Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
function initURLTarget() {
  $("[data-url_target]").click(function () {
    var url = $(this).data("url_target");
    if (url && url !== "#") {
      window.location.href = url;
    }
  });
}

// Fonction pour vérifier la présence de la classe 'menu-opening' et ajouter 'header_mobile' (= le fond blur)
  function checkMenuOpening() {
    if ($('.menu-drawer-container').hasClass('menu-opening')) {
      $('.header-wrapper').addClass('header_mobile');
    } else {
      $('.header-wrapper').removeClass('header_mobile');
    }
  }

// Initialisation des Swipers de carte produit
function initSwipers() {
  document.querySelectorAll('.swiper').forEach((swiperEl, index) => {
    let swiper = new Swiper(swiperEl, {
      direction: 'horizontal',
      loop: true,
      speed: 300,
      effect: 'fade', // Par défaut "slide" sur mobile
      fadeEffect: {
        crossFade: true
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: {
        enabled: true,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar'
      }
    });

    // Ajout de l'effet hover sur la carte produit
    let productCard = swiperEl.closest('.product_item'); // S'assurer qu'on cible bien la carte produit
    if (productCard) {
      productCard.addEventListener('mouseenter', () => {
        swiper.slideTo(1); // Passe à la deuxième image
      });

      productCard.addEventListener('mouseleave', () => {
        swiper.slideTo(0); // Retourne à la première image
      });
    }
  });
}

// Fonction pour ajuster la date de livraison
function adjust_delivery_time() {
  var delivery_time = 72; // Nombre moyen d'heures pour être livré
  var now = new Date();
  var delivery_date = new Date();

  // Si on est le vendredi après 12h
  if (delivery_date.getDay() == 5 && delivery_date.getHours() >= 11) {
    delivery_date = delivery_date.addHours(24);
  }

  // Si on est un samedi ou dimanche, on repousse au lundi suivant
  if (now.getDay() == 6 || now.getDay() == 0) {
    var nb_weekend_day = delivery_date.getDay() == 6 ? 2 : 1;
    delivery_date = delivery_date.addHours(nb_weekend_day * 24);
  }

  delivery_date = delivery_date.addHours(delivery_time); // Jour de livraison supposé, hors jour chômés

  // Si on tombe sur une date de livraison un dimanche, on ajoute 24h.
  if (delivery_date.getDay() == 0) {
    delivery_date = delivery_date.addHours(24);
  }

  // Affichage
  var numero_jour_livraison = delivery_date.getDate();
  var nom_jour_livraison = delivery_date.toLocaleDateString("fr-FR", { weekday: 'long' });
  var nom_mois_livraison = delivery_date.toLocaleDateString("fr-FR", { month: 'long' });
  $(".estimated_delivery span").html(nom_jour_livraison + " " + numero_jour_livraison + " " + nom_mois_livraison);
  $(".estimated_delivery").fadeIn();
}

// Ajoute h Heures à une date existante
Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + (h * 60 * 60 * 1000));
  return this;
}

// Fonction pour vérifier si un élément est visible dans la fenêtre
function isInViewport(el) {
  if (typeof el.get(0) === 'undefined') {
    return false;
  }

  const rect = el.get(0).getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= ($(window).height() || $(document).height()) &&
    rect.right <= ($(window).width() || $(document).width())
  );
}
